import { readStoredValue, writeStoredValue } from './storedValue'

const STORED_MAPEO_DONE_KEY = 'storedMapeoDone'
const STORED_DRAWING_TYPE_KEY = 'storedDrawingType'

const parseStoredBoolean = (value: string | null): boolean | null => {
  if (value === 'true') return true
  if (value === 'false') return false
  return null
}

let storedMapeoDone = parseStoredBoolean(readStoredValue(STORED_MAPEO_DONE_KEY))
let storedDrawingType = readStoredValue(STORED_DRAWING_TYPE_KEY)

export const getStoredMapeoDone = (): boolean | null => storedMapeoDone

export const setStoredMapeoDone = (done: boolean | null): void => {
  storedMapeoDone = done
  writeStoredValue(STORED_MAPEO_DONE_KEY, done === null ? null : String(done))
}

export const getStoredDrawingType = (): string | null => storedDrawingType

export const setStoredDrawingType = (type: string | null): void => {
  storedDrawingType = type
  writeStoredValue(STORED_DRAWING_TYPE_KEY, type)
}
